import { isPageValue } from './isPageValue';
import { isMenuHidden } from './isMenuHidden';

export const hasNavigationBar = () => !isPageValue() && !isMenuHidden();
